import { getFirstDivisionInfo } from '@/core/auth/utils'

export default {
    orders: [],
    errorOrdersData: [],
    totalOrders: 0,
    paramsSearch: {
        num: null,
        status: null,
        dep_id: getFirstDivisionInfo().id,
        'order-date': null,
    },
    statuses: [],
}
